<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>邮件模板</span>
          <el-button
            v-permisaction="['config:sysMail:add']"
            style="margin-top: 10px;margin-left: 10px;"
            type="primary"
            icon="el-icon-plus"
            size="mini"
            @click="edit(0)"
          >新增</el-button>
          <clear-cache-apply url="/config/sys-email/list" />
        </div>
        <el-table
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="id"
            label="ID"
            align="center"
          />
          <el-table-column
            prop="online_start"
            label="标题"
            width="200"
            align="center"
          >
            <template v-slot:default="scope">
              <span v-if="scope.row.title.ZH">{{ scope.row.title.ZH }}</span>
              <span v-else>{{ scope.row.title.EN }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="online_end"
            label="内容"
            width="200"
            align="center"
          >
            <template v-slot:default="scope">
              <span v-if="scope.row.body.ZH">{{ scope.row.body.ZH }}</span>
              <span v-else>{{ scope.row.body.EN }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="start_time"
            label="开始时间"
            width="200"
            align="center"
          />
          <el-table-column
            prop="end_time"
            label="结束时间"
            width="200"
            align="center"
          />
          <el-table-column
            prop="level_start"
            label="开始等级"
            align="center"
          />
          <el-table-column
            prop="level_end"
            label="结束等级"
            align="center"
          />
          <!--          <el-table-column-->
          <!--            prop="score_start"-->
          <!--            label="开始积分"-->
          <!--          />-->
          <!--          <el-table-column-->
          <!--            prop="score_end"-->
          <!--            label="结束积分"-->
          <!--          />-->
          <el-table-column
            prop="sid"
            label="设备"
            align="center"
            :formatter="sidFormatter"
          />
          <el-table-column
            prop="days"
            label="显示天数"
            align="center"
          />
          <el-table-column
            prop="rewards"
            label="奖励"
            align="center"
            :formatter="rewardFormatter"
          />
          <el-table-column
            prop="right"
            label="操作"
            width="200"
            align="center"
          >
            <template v-slot:default="scope">
              <el-button v-permisaction="['config:sysMail:edit']" type="text" size="small" @click="edit(scope.row.id)">编辑</el-button>
              <el-button v-permisaction="['config:sysMail:copy']" type="text" size="small" @click="copy(scope.row.id)">拷贝</el-button>
              <!--              <el-button v-permisaction="['config:sysMail:del']" type="text" size="small" @click="del(scope.row.id)">删除</el-button>-->
            </template>
          </el-table-column>
        </el-table>
        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { copyMailCfgList, delMailCfg, getMailCfgList } from '@/api/config/email-cfg'
import { getRewardListForPropsId } from '@/utils'
import { getRewardType } from '@/api/config/slot'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
export default {
  name: 'Email',
  components: { ClearCacheApply },
  data() {
    return {
      rewardType: [],
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        type: 1
      },
      total: 0,
      tableData: [
        {
          'id': 0,
          'online_start': '',
          'online_end': '',
          'start_time': '',
          'end_time': '',
          'level_start': 0,
          'level_end': 0,
          'score_start': 0,
          'score_end': 0,
          'sid': 1,
          'days': 0,
          'version': ''
        }
      ]
    }
  },
  created() {
    this.getRewardTypeData()
    this.getTables()
  },
  methods: {
    del(id) {
      this.$confirm('你确定要删除该数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '再看看',
        type: 'warning'
      }).then(() => {
        delMailCfg({ id: id }).then(res => {
          this.msgSuccess('删除成功')
          this.getTables()
        })
      })
    },
    copy(id) {
      copyMailCfgList({ id: id }).then(res => {
        if (res.code === 200) {
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getMailCfgList(this.queryParams).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.list
          this.total = res.data.count
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    edit(id) {
      this.$router.push({ name: 'EmailEdit', query: { id: id, type: this.queryParams.type }})
    },
    sidFormatter(row, column) {
      if (row.sid === 1) {
        return '安卓'
      } else if (row.sid === 2) {
        return 'ios'
      } else {
        return '全部'
      }
    },
    rewardFormatter(row) {
      return getRewardListForPropsId(row.rewards, this.rewardType)
    }
  }
}
</script>

<style scoped>
</style>
